// src/components/search/hooks/useDocumentDownload.ts

import { useState } from 'react';
import { AppDispatch } from '@/app/store';
import { fetchDocumentUrl } from '@/features/documents/documentsThunks';
import { fetchFormUrl } from '@/features/documents/formsThunks';
import { downloadFile } from '@/utils/downloadFile';

export const useDocumentDownload = (dispatch: AppDispatch) => {
  const [downloading, setDownloading] = useState<string | null>(null);

  const handleDownload = async (storagePath: string, fileName: string, isForm: boolean = false) => {
    try {
      setDownloading(storagePath);
      // Use fetchFormUrl for forms, fetchDocumentUrl for institutional documents
      const downloadUrl = isForm
        ? await dispatch(fetchFormUrl({ storagePath })).unwrap()
        : await dispatch(fetchDocumentUrl({ storagePath })).unwrap();
      await downloadFile(downloadUrl, fileName);
    } catch (error) {
      console.error('Error downloading file:', error);
    } finally {
      setDownloading(null);
    }
  };

  return { downloading, handleDownload };
};
